import React, { useState, useEffect } from 'react'
import { db } from './firebase';
import "./Orders.css"
import { useStateValue } from './StateProvider';
import Order from './Order';
function Orders() {
    const [{ _, user }] = useStateValue();
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        if (user) {
            db.collection('users')
                .doc(user.uid)
                .collection('orders')
                .orderBy('created', 'desc')
                .onSnapshot(snapshot => (
                    setOrders(snapshot.docs.map(doc => ({
                        id: doc.id,
                        data: doc.data()
                    })))
                ));
        } else {
            setOrders([]);
        }
    }, [user]);

    return (
        <div className="orders">
            {user ? (<h1>Your Orders</h1>) : <h1>Please sign in or create an Account to view your Orders</h1>}
            <div className="orders_order">
                {orders.map(order => (
                    <Order order={order} />
                ))}
            </div>
        </div>
    )
}

export default Orders